import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Card } from '../../../shadcn/components/ui/card'

export const TotalPrice = ({
  totalHT,
  totalTTC,
}: {
  totalHT: string
  totalTTC: string
}) => {
  return (
    <Card className='flex h-full w-full items-center justify-between border-none bg-grey-300 p-4 font-semibold'>
      <span>
        <FormattedMessage
          id='ui.totalPrice.total.label'
          defaultMessage='Total'
        />
      </span>
      <div className='flex items-center gap-8'>
        <span>
          <FormattedMessage
            id='ui.totalPrice.HT'
            defaultMessage='{totalHT} HT'
            values={{ totalHT }}
          />
        </span>
        <span>
          <FormattedMessage
            id='ui.totalPrice.TTC'
            defaultMessage='{totalTTC} TTC'
            values={{ totalTTC }}
          />
        </span>
      </div>
    </Card>
  )
}
